// Auto-generated TypeScript enum from PHP enum

export type CalendarLinkType = 'apple' | 'google' | 'outlook';

export const CalendarLinkType = {
  Apple: 'apple' as const,
  Google: 'google' as const,
  Outlook: 'outlook' as const,
} as const;

export const CalendarLinkTypeUtils = {
  values: Object.values(CalendarLinkType),
  keys: Object.keys(CalendarLinkType) as Array<keyof typeof CalendarLinkType>,
  entries: Object.entries(CalendarLinkType) as Array<[keyof typeof CalendarLinkType, CalendarLinkType]>,
  isValid: (value: any): value is CalendarLinkType => Object.values(CalendarLinkType).includes(value),
  fromKey: (key: keyof typeof CalendarLinkType): CalendarLinkType => CalendarLinkType[key],
};

